import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'ap-jumbotron',
    templateUrl: './jumbotron.component.html',
    styleUrls: ['./jumbotron.component.css'],
    standalone: false
})
export class JumbotronComponent implements OnInit {

  @Input() icon: string;

  constructor() { }

  ngOnInit() {
  }

}
